// src/context/AlertContext.js
import { createContext } from 'react'
export const AlertContext = createContext(null)
